import { takeLatest } from 'redux-saga/effects';

import { adminActionTypes } from '@/redux/actions';
import apiConfig from '@/constants/apiConfig';

import { processCallbackAction, processLoadingAction } from '../helper';

const {
    GET_LIST,
    GET_ROLE_LIST,
    GET_DETAIL,
    CREATE,
    UPDATE,
    UPDATE_STATUS,
    ASSIGN_APP,
    GET_APP_ASSIGNED,
    GET_LIST_APP,
} = adminActionTypes;

const getList = (action) => {
    return processCallbackAction(apiConfig.admin.getList, action);
}

const getRoleList = (action) => {
    return processCallbackAction(apiConfig.admin.getRoleList, action);
}

const getDetail = ({ payload }) => {
    const { params, onCompleted, onError } = payload;
    const apiOptions = {
        ...apiConfig.admin.getDetail,
        path: apiConfig.admin.getDetail.path.replace(':id', params.id)
    }
    return processCallbackAction(apiOptions, { payload: { params: {}, onCompleted, onError }});
}

const create = (action) => {
    return processCallbackAction(apiConfig.admin.create, action);
}

const update = (action) => {
    return processCallbackAction(apiConfig.admin.update, action);
}

const updateStatus = (action) => {
    return processCallbackAction(apiConfig.admin.updateStatus, action);
}

const assignApps = (action) => {
    return processCallbackAction(apiConfig.admin.assignApp, action);
}

const getListApp = (action) => {
    return processLoadingAction(apiConfig.admin.getListApp, action);
}

const getAppAssigned = (action) => {
    return processLoadingAction(apiConfig.admin.getAppAssigned, action);
}

const adminSagas = [
    takeLatest(GET_LIST, getList),
    takeLatest(GET_ROLE_LIST, getRoleList),
    takeLatest(CREATE, create),
    takeLatest(GET_DETAIL, getDetail),
    takeLatest(UPDATE, update),
    takeLatest(UPDATE_STATUS, updateStatus),
    takeLatest(ASSIGN_APP, assignApps),
    takeLatest(GET_LIST_APP, getListApp),
    takeLatest(GET_APP_ASSIGNED, getAppAssigned),
];

export default adminSagas;